module.exports = __webpack_public_path__ + "img/new_offer_icon.c9012e81.png";